import { render, staticRenderFns } from "./PurchaseChart.vue?vue&type=template&id=4c475655&"
import script from "./PurchaseChart.vue?vue&type=script&lang=js&"
export * from "./PurchaseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports